import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { get } from 'lodash';
import React, { FC } from 'react';
import { ANTRAG_TYP, EINREICHUNG_DER_UNTERLAGEN } from 'src/lib/constants/constant';
import { InhaltTrenner } from 'src/pages/private/online-antrag/antrag-components/Wrapper';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

/**
 * ***********************************************************************
 * ***** Diese Information werden nach dem Download-Button angezeigt *****
 * ***********************************************************************
 */
export const RUSNachdemDownloadInformation: FC<{ application: any }> = ({ application }) => {
	const EinreichungDerUnterlagen = get(application, P.Foerderprogramm.schema.attributes.Konfiguration_Einreichung_Der_Antragsunterlagen.path, '');

	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.digital) {
		return (
			<>
				<Typography>
					<strong>Bitte beachten Sie:</strong> Die Unterzeichnung der RUS-Selbsterklärung kann per eigenhändiger Unterschrift erfolgen. Ebenso
					zulässig ist es, die Erklärung elektronisch mit eingescannter Unterschrift oder Signatur zu unterzeichnen.
				</Typography>
			</>
		);
	}
	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.postalisch) {
		return (
			<>
				<Typography>
					<strong>Bitte beachten Sie:</strong> Die Unterzeichnung der RUS-Selbsterklärung muss per eigenhändiger Unterschrift erfolgen. Das
					Einfügen einer Bilddatei o.Ä. als Unterschrift ist nicht zulässig. Bitte speichern Sie die unterzeichnete Erklärung anschließend als
					pdf- Datei ab.
				</Typography>
			</>
		);
	}

	return <></>;
};

/**
 * ***********************************************************************
 * ******** Diese Information werden vor dem Upload-Feld angezeigt *******
 * ***********************************************************************
 */
export const RUSVordemUploadInformation: FC<{ application: any }> = ({ application }) => {
	const EinreichungDerUnterlagen = get(application, P.Foerderprogramm.schema.attributes.Konfiguration_Einreichung_Der_Antragsunterlagen.path, '');

	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.digital) {
		return (
			<>
				<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
					Upload der RUS-Erklärung
				</Typography>
				<Typography>Bitte laden Sie hier die unterzeichnete RUS-Selbsterklärung als pdf-Datei hoch:</Typography>
			</>
		);
	}
	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.postalisch) {
		return (
			<>
				<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
					Upload der RUS-Erklärung
				</Typography>
				<Typography>
					Bitte laden Sie hier die unterzeichnete RUS-Selbsterklärung (pdf-Datei) als Vorab-Information über das Upload-Feld hoch:
				</Typography>
			</>
		);
	}

	return <></>;
};

/**
 * ***********************************************************************
 * ************* Hier sind die Informationen zum Postversand *************
 * ***********************************************************************
 */
const RusPostVersandInfo: FC<{ application: any }> = ({ application }) => {
	// const antragsFormular = get(application, P.Allgemein_Antragsformular.path, '');
	const antragTyp = get(application, P.Allgemein_Typ.path, '');
	const isSkizze = antragTyp === ANTRAG_TYP.Skizze;
	const EinreichungDerUnterlagen = get(application, P.Foerderprogramm.schema.attributes.Konfiguration_Einreichung_Der_Antragsunterlagen.path, '');

	const textToRender = [];

	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.postalisch) {
		textToRender.push(
			<>
				<Stack spacing={3} sx={{ mt: '1rem' }}>
					<InhaltTrenner />
					<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
						Einreichung der RUS-Selbsterklärung
					</Typography>
					<Typography>
						Die RUS-Selbsterklärung ist Bestandteil des Förderantrags. Bitte lassen Sie uns diese - zusammen mit den weiteren Antragsdokumenten
						- fristgerecht im Original zukommen. Weitere Informationen finden Sie im Menüpunkt{' '}
						{isSkizze ? '„Skizze einreichen“' : '„Antragseinreichung“'}.
					</Typography>
					<Box sx={{ mb: '5rem !important' }}>{/*Platzhalter element*/}</Box>
				</Stack>
			</>,
		);
	}

	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.digital) {
		textToRender.push(
			<>
				<Stack spacing={3} sx={{ mt: '1rem' }}>
					<InhaltTrenner dotted={true} />
					<Typography>
						<strong>Wichtig:</strong> Die unterzeichnete RUS-Selbsterklärung ist Bestandteil des Förderantrags. Der Upload der Erklärung an
						dieser Stelle ist daher wichtig für die Einreichung Ihres vollständigen Antrags auf Förderung.
					</Typography>
				</Stack>
			</>,
		);
	}

	return <>{textToRender}</>;
};
export default RusPostVersandInfo;
